import { authorizedEdgeFetch } from 'app/axios/edge'
import { MyAccountFormValues } from './types'

export const getUserInfo = (userId: string) =>
  authorizedEdgeFetch.get(`/users/${userId}`)

export const updateUser = (userId: string, accountInfo: MyAccountFormValues) =>
  authorizedEdgeFetch.put(`/users/${userId}`, accountInfo)
